/** Rótulo semântico curto. Cor por texto + fundo lavado, nunca cor sozinha. */
import type { ReactNode } from 'react';

export type BadgeVariant = 'neutral' | 'positive' | 'attention' | 'alert' | 'accent';

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

export function Badge({ children, variant = 'neutral', className }: BadgeProps) {
  return <span className={['badge', `badge-${variant}`, className].filter(Boolean).join(' ')}>{children}</span>;
}
